import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nuestra-ciencia',
  templateUrl: './nuestra-ciencia.component.html',
  styleUrls: ['./nuestra-ciencia.component.css']
})
export class NuestraCienciaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
